<div class="modal-confirmacao-container">
  <p class="modal-mensagem">{{ data.mensagem }}</p>
  <div class="modal-botoes">
    <button class="btn-confirmar" (click)="confirmar()">Confirmar</button>
    <button class="btn-cancelar" (click)="cancelar()">Cancelar</button>
  </div>
</div>

